<style lang="less" scoped>
// @keyframes move {
//     0%{
//         top:100px;
//     }    
//     99%{
//         z-index: 1;
//     }
//     100%{
//         top:695px;
//         z-index: 3;
//     }
// }
@keyframes scale {
    0%{
        transform: scale(1);
    }  
    50%{
        transform: scale(1.2)
    }  
    100%{
        transform: scale(1)
    }
}
    .wrapper{
        padding-top: 50px;
        .banner{
            width: 674px;
            height: 488px;
            position: relative;
            background:#fff url("../../assets/images/audit/banner.png") no-repeat;
            background-size: 100%;
            margin:0 auto;
            z-index: 3;
            .banner-title{
                position: absolute;
                top:172px;
                left:254px;
                color:#151515;
                font-size: 32px;
                font-weight: 700;
            }
            .banner-text{
                position: absolute;
                left:120px;
                top:240px;
                font-size: 26px;
                color:#151515;
                line-height:1.5;
                font-weight: 700;
            }
            .refresh{
                position:absolute;
                background:url("../../assets/images/audit/refresh.jpg") no-repeat;
                background-size:100% 100%;
                width: 100px;
                height: 100px;
                top:50px;
                right:50px;
            }
            .clickble{
                position:absolute;
                background:url("../../assets/images/audit/clickble.jpg") no-repeat;
                background-size:100% 100%;
                width: 50px;
                height: 50px;
                top:130px;
                right:40px;
                animation: scale .5s linear infinite ;
            }
        }
        // .btn-container{
        //     width: 674px;
        //     height: 90px;
        //     padding:50px 0;
        //     margin:0 auto;
        //     background: #fff;
        //     position: relative;
        //     z-index: 3;
        //     .btn-submit{
        //         display:block;
        //         line-height: 90px;
        //         color:#fff;
        //         text-align: center;
        //         background:#CEBBFB;
        //         font-size: 32px;
        //         border-radius: 20px;
        //     }
        // }
        .estimation{
            position: relative; 
            z-index: 2;                      
            .est-title{
                background:#fff url("../../assets/images/audit/banner-2.png") no-repeat;
                background-size: 100%;
                width: 710px;
                height: 182px;
                margin:0 auto;
                text-align: center;
                // padding:50px 0;
                font-size: 32px;
                line-height: 150px;
            }
            .black-placeholder{
                position: absolute;
                top:125px;
                width: 620px;
                height: 10px;
                background:#333;
                margin: 0 auto;
                border-radius: 10px;
                left:75px;
            }                        
        }
        .calculation{
            position: absolute;
            top:695px;
            left:85px;
            width: 520px;
            height:530px;
            overflow: hidden;
            background:#fff;                
            border:2px solid #CEBBFB;
            // animation: move 1.5s 1s ease-in  forwards;
            padding:40px;
            z-index: 3;
            .cal-title{
                color:#151515;
                font-size: 26px;
                font-weight: 700;
                margin-bottom: 30px;
            }
            .cal-caption{
                font-size: 24px;
                color:#151515;
                line-height:1.5;
                margin-top: 20px;
            }
            .cal-table{
                
                .cal-head{
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    .cal-head-element{
                        text-align:center;
                        background:#CEBBFB;
                        line-height: 60px;
                        color:#151515;
                        height: 60px;
                        font-size: 28px;
                        &:first-child{
                            width: 200px;
                            line-height: 60px;
                            margin-right: 2px;
                        }
                        &:last-child{
                            width: 320px;
                            height: 60px;
                            line-height: 60px;
                        }
                    }
                }
                .cal-row{
                    display: flex;
                    justify-content: space-around;
                    align-items: center;
                    .cal-element{
                        margin-top: 5px;
                        font-size: 28px;                        
                        strong{
                            position: absolute;
                            font-size: 36px;
                            color:#FE3B30;
                            animation: scale .5s linear infinite ;
                        }
                        &:first-child{
                            background:#F2ECFE;
                            width: 212px;
                            height: 60px;
                            line-height: 60px;
                            color:#151515;
                            margin-right: 2px;
                            text-align:center;
                        }
                        &:last-child{
                            text-align:left;
                            background:#F2ECFE;
                            width: 256px;
                            height: 60px;
                            line-height: 60px;
                            padding-left: 70px;
                            color:#151515
                        }
                    }
                    
                }
            }
        }
    }
    .placeholder{
        width: 100%;
        height: 30px;
        background:#fff;
        position: relative;
        z-index: 2;
    }

</style>
<template>
    <div class="wrapper">
        <div class="banner">
            <h2 class="banner-title">In Auditing</h2>
            <p class="banner-text">
                It need take a few minutes We will notify<br>you vía SMS
            </p>
            <div class="refresh" @click.prevent="update"></div>
            <div class="clickble" @click.prevent="update"></div>
        </div>
        <!-- <div class="btn-container">
            <a class="btn-submit" @click.prevent="update">Update Status</a>
        </div> -->
        <div class="placeholder"></div>
        <div class="estimation">
            <h2 class="est-title">Estimation Result</h2>
            <div class="black-placeholder"></div>            
        </div>        
        <div class="calculation">                
                <h3 class="cal-title">Loan Calculation</h3>
                <div class="cal-table">
                    <div class="cal-head">
                        <div class="cal-head-element">Number of loans</div>
                        <div class="cal-head-element">Loan Amount</div>
                    </div>
                    <div class="cal-row">
                        <div class="cal-element">1</div>
                        <div class="cal-element">1000 - 5000</div>
                    </div>
                    <div class="cal-row">
                        <div class="cal-element">3</div>
                        <div class="cal-element">3000 - 10000</div>
                    </div>
                    <div class="cal-row">
                        <div class="cal-element">5</div>
                        <div class="cal-element">5000 - <strong>40000</strong></div>
                    </div>
                </div>
                <div class="cal-caption">Loan calculations are made for you based on your credit evaluation and number of borrowings.</div>
                <div class="cal-caption">Paying your bills on time increases your credit score</div>
            </div>
    </div>
</template>
<script>
import { orderDetail } from "@api/index";
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
export default {
    setup () {
        const router = useRouter()
        const route = router.currentRoute.value
        const loading = useLoading()
        const clicked = ref(false)
        onMounted(()=>{
            // const loader = loading.show({
            //     container:null
            // })
            // setTimeout(()=>{
            //     loader.hide()
            // },1000)
        })
        const update = () => {    
            if(clicked.value)return
            clicked.value = true
            const loader = loading.show({
                container: null
            })
            orderDetail({
                orderId:route.params.id
            }).then((res)=>{
                loader.hide()
                clicked.value = false
                if(res.code == 0) {                    
                    if(res.data.orderState == 2) {
                        router.replace({
                            path:`/orders/${res.data.orderId}/confirm`
                        })
                    } else if (res.data.orderState >= 4) {
                        router.replace({
                            path:'/order'
                        })
                    }
                }
            })
        }
        return {
            update
        }
    }
}
</script>
